import React, { useState } from 'react'
import { Tooltip } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import * as DarkReader from 'darkreader';
import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
import { useDispatch } from 'react-redux';
import { slideAction } from '../../store/slideSlice';

function Modes() {
    DarkReader.setFetchMethod(window.fetch);
    const [darkMode, setDarkMode] = useState(true);
    const dispatch = useDispatch();

    const setMode = () => {
        if (darkMode) {
            enableDarkMode({ brightness: 100, contrast: 90, sepia: 10 });
        } else {
            disableDarkMode();
        }
        setDarkMode(!darkMode);
        dispatch(slideAction.setDarkMode(!darkMode));
    };

    return (
        <Tooltip title={darkMode ? 'Dark mode' : 'Light mode'} placement="bottom">
            <button className="header-icon-btn" onClick={setMode} aria-label="Toggle dark mode">
                {darkMode
                    ? <BulbOutlined style={{ fontSize: '17px' }} />
                    : <BulbFilled style={{ fontSize: '17px', color: '#facc15' }} />
                }
            </button>
        </Tooltip>
    );
}

export default Modes